module.exports = __webpack_public_path__ + "static/media/logo_acentra.94d946e8.svg";